module.exports = "./favicon.ico";